var _path, _path2;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTickSquare = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9997 37.9168H14.9997C5.94967 37.9168 2.08301 34.0502 2.08301 25.0002V15.0002C2.08301 5.95016 5.94967 2.0835 14.9997 2.0835H24.9997C34.0497 2.0835 37.9163 5.95016 37.9163 15.0002V25.0002C37.9163 34.0502 34.0497 37.9168 24.9997 37.9168ZM14.9997 4.5835C7.31634 4.5835 4.58301 7.31683 4.58301 15.0002V25.0002C4.58301 32.6835 7.31634 35.4168 14.9997 35.4168H24.9997C32.683 35.4168 35.4163 32.6835 35.4163 25.0002V15.0002C35.4163 7.31683 32.683 4.5835 24.9997 4.5835H14.9997Z",
    fill: "#455CC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6344 25.9668C17.301 25.9668 16.9844 25.8335 16.751 25.6002L12.0344 20.8835C11.551 20.4002 11.551 19.6002 12.0344 19.1168C12.5177 18.6335 13.3177 18.6335 13.801 19.1168L17.6344 22.9502L26.201 14.3835C26.6844 13.9002 27.4844 13.9002 27.9677 14.3835C28.451 14.8668 28.451 15.6668 27.9677 16.1502L18.5177 25.6002C18.2844 25.8335 17.9677 25.9668 17.6344 25.9668Z",
    fill: "#455CC7"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTickSquare, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/tick-square.7004c3d2.svg";
export { ForwardRef as ReactComponent };